import { type NuxtAxiosInstance } from '@/types/axios'

export async function getPromoCampaign(axios: NuxtAxiosInstance, promoCampaignId: number, isLogin = true) {
  const path = isLogin ? `/promo_campaign/${promoCampaignId}` : `/pub/promo_campaign/${promoCampaignId}`
  const res = await axios.$get(path)

  if (res.code !== 0) {
    throw res
  }

  return res
}
